import { eTitleSearchStatus } from './eTitleSearchStatus';

export interface IPayoffRequestResponse {
  id: string;
  orderId: string;
  vendorCompanyId: string;
  status: eTitleSearchStatus;
  createdAt: string;
  updatedAt?: string;
  eta?: string;
}

export type IPayoffRequestData = IPayoffRequestResponse;

export const convertFromPayoffRequestResponseToPayoffRequestData = (data: IPayoffRequestResponse): IPayoffRequestData =>
  data;
export const convertFromPayoffRequestDataToPayoffRequestResponse = (data: IPayoffRequestData): IPayoffRequestResponse =>
  data;

export const convertFromPayoffRequestResponseArrayToPayoffRequestDataArray = (
  data: IPayoffRequestResponse[]
): IPayoffRequestData[] => data;
export const convertFromPayoffRequestDataArrayToPayoffRequestResponseArray = (
  data: IPayoffRequestData[]
): IPayoffRequestResponse[] => data;
